import { toast } from '@systemeio/ui'
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view'
import { useSendNewsletter } from 'modules/newsletters/single/hooks/use-send-newsletter'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import Confirmation from 'shared/components/confirmation-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export interface SaveAndSendNewsletterModalProps {
  onSave: () => Promise<void>
  onClose: () => void
  opened: boolean
  newsletterId: NewsletterId
  isTagsSelected: boolean
  confirmationText: string
}

export const SaveAndSendNewsletterModal = ({
  onClose,
  opened,
  onSave,
  newsletterId,
  isTagsSelected,
  confirmationText,
}: SaveAndSendNewsletterModalProps) => {
  const { t } = useLocoTranslation()

  const { fetcherSendNewsletter } = useSendNewsletter()

  const { mutateNewslettersData } = useGetNewsletterView({
    newsletterId,
  })

  const onConfirm = async () => {
    try {
      if (isTagsSelected) {
        await onSave()
        await fetcherSendNewsletter(newsletterId)
        await mutateNewslettersData(data => data && { ...data, sent: true }, false)
      } else {
        toast.error(t('dashboard.newsletter_editor.select_tags_warning_message'))
      }
    } catch (e) {
      throw e
    }
  }
  return (
    <>
      <Confirmation
        opened={opened}
        onClose={onClose}
        onConfirm={onConfirm}
        confirmationText={confirmationText}
      />
    </>
  )
}
